import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { Aggregate, AllocationPayload, CostApi, Window } from './CostApi';

export class CostClient implements CostApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getAllocation(window: Window, aggregate: Aggregate): Promise<AllocationPayload> {
    const baseUrl = await this.discoveryApi.getBaseUrl('cost');
    const res = await this.fetchApi.fetch(
      `${baseUrl}/allocation?window=${window}&aggregate=${aggregate}`,
    );
    if (!res.ok) {
      throw new Error(`Erreur ${res.status}`);
    }
    return res.json();
  }
}
